import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const memoryRuntime = createHostModule({
    clear: ({ channel }) => function clear(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'memory.clear',
            args,
        });
    },
    getItem: ({ channel }) => function getItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'memory.getItem',
            args,
        });
    },
    removeItem: ({ channel }) => function removeItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'memory.removeItem',
            args,
        });
    },
    setItem: ({ channel }) => function setItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'memory.setItem',
            args,
        });
    },
});
//# sourceMappingURL=memory.runtime.js.map